// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__lt-yv","badge":"tabs_badge__wX-PZ","badge-yellow":"tabs_badge-yellow__vX+26","badge-green":"tabs_badge-green__JrUnz","badge-red":"tabs_badge-red__yGYID"};